module.exports = __webpack_public_path__ + "static/fonts/iconfont.b8a522f.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/iconfont.ttf?t=1555750596622
// module id = HLI+
// module chunks = 38